import { BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ConditionElseEntryLine = styled("div")<BoxProps>(({ theme }) => ({
  position: "absolute",
  borderLeft: "var(--tree-lines-width, 2px) solid var(--if-else-lines-color)",
  borderBottom: "var(--tree-lines-width, 2px) solid var(--if-else-lines-color)",
  width: `var(--if-else-line-offset)`, //"20px",
  left: "calc(var(--if-else-line-offset) * -1)", //theme.spacing(-1.5),
  bottom: `calc(50% + ${theme.spacing(1)})`,
  top: theme.spacing(-1.5),
  "&::before": {
    content: '""',
    position: "absolute",
    width: "9px",
    height: "9px",
    bottom: "calc(-1 * var(--tree-lines-width, 2px) / 2)",
    borderBottom: "var(--tree-lines-width, 2px) solid var(--if-else-lines-color)",
    borderRight: "var(--tree-lines-width, 2px) solid var(--if-else-lines-color)",
    transformOrigin: "bottom right",
    transform: "rotate(-45deg)",

    left: "calc(3px + var(--tree-lines-width, 2px))", //"7px",
    [theme.breakpoints.down("md")]: {
      left: "calc(0px + var(--tree-lines-width, 2px))", //"7px",
    },
  },
}));
